import participants from '~/modules/documents/mixins/participants'
import responsive from '~/mixins/pages/responsive'
import contentDialog from '~/mixins/dialogs/contentDialog'
import clipboard from '~/mixins/global/_clipboard'
import successSnackbar from '~/modules/snackbar/mixins/successSnackbar'
import contentDialogContentTop from '~/mixins/dialogs/contentDialogContentTop'
import documentActions from '~/modules/documents/mixins/documentActions'
import { isSafari } from '~/services/_utils/utils'
import { PARTICIPANTS_ROLES } from '~/modules/documents/constants/participants'

const shareDocumentActions = {
  mixins: [
    participants,
    responsive,
    contentDialog,
    contentDialogContentTop,
    clipboard,
    successSnackbar,
    documentActions
  ],
  data() {
    return {
      generatedLink: null,
      generateLoading: false,
      copyLoading: false
    }
  },
  computed: {
    filledFields() {
      return this.$store.getters['templatefields/filledFields']
    }
  },
  methods: {
    async generateLink(document, action) {
      try {
        this.generateLoading = true
        if (this.filledFields.length) {
          await this.fillDynamicFields(document)
        }
        const actionMap = {
          view: this.participantActionsMap.VIEW,
          fill: this.participantActionsMap.FILL,
          sign: this.participantActionsMap.SIGN,
          approve: this.participantActionsMap.APPROVE
        }
        const publicAction =
          action || actionMap[document?.publicAccessType] || this.participantActionsMap.SIGN

        if (this._.get(document, 'hasBundle')) {
          const response = await this.generateBundleLink(document, publicAction)
          const bundleLink = this._.get(response, 'data.publicLink')
          this.generatedLink = bundleLink
        } else {
          this.generatedLink = this._.get(
            await this.$store.dispatch('documents/generateDocumentLink', {
              id: document.id,
              payload: { action: publicAction }
            }),
            'data.link'
          )
        }

        return this.generatedLink
      } catch (e) {
        this.$handlers.error(e, this)
        return null
      } finally {
        this.generateLoading = false
      }
    },
    generateBundleLink(document, action) {
      try {
        const publicAccess =
          action === this.participantActionsMap.SIGN
            ? PARTICIPANTS_ROLES.SIGNER
            : PARTICIPANTS_ROLES.VIEWER
        return this.$store.dispatch('bundles/publicLink', {
          id: this._.get(document, 'bundleInfo.id'),
          payload: { publicAccess }
        })
      } catch (e) {
        this.$handlers.error(e, this)
        return null
      }
    },
    async handleCopyLink(document, inDialog = false, action = null) {
      try {
        this.copyLoading = true
        if (this.filledFields.length && this.generatedLink) {
          await this.fillDynamicFields(document)
        }

        await this.generateLink(document, action)
        if (!this.generatedLink) return

        if (this.xsDevice || this.smDevice || isSafari) {
          this.openCopyLinkDialog(inDialog, {
            component: 'm-block-input-copy',
            width: '512px',
            componentProps: {
              title: this.$t('Copy public link'),
              value: this.generatedLink
            }
          })
        } else {
          this.copy(this.generatedLink)
          this.successSnackbar.open({
            text: this.$t('Copied to clipboard')
          })
        }
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.copyLoading = false
      }
    },
    async handleShareMessenger(document, messenger, action = null) {
      if (this.filledFields.length && this.generatedLink) {
        await this.fillDynamicFields(document)
      }
      await this.generateLink(document, action)
      if (!this.generatedLink) return

      const shareText = this.$t('Share document with you')
      const fullMessage = `${shareText}\n${this.generatedLink}`
      const messengerUrls = {
        whatsapp: `https://wa.me/?text=${encodeURIComponent(fullMessage)}`,
        telegram: `https://t.me/share/url?url=${encodeURIComponent(this.generatedLink)}&text=${encodeURIComponent(shareText)}`,
        viber: `viber://forward?text=${encodeURIComponent(fullMessage)}`
      }
      const url = messengerUrls[messenger]
      if (!url) return
      window.open(url, '_blank')
      window.dataLayer?.push({
        event: 'share_public_link',
        messenger,
        email: this.$User?.email
      })
    },
    handleNotifySms(isProVersion = false) {
      this.successSnackbar.open({
        text: this.$t('We will notify you as soon as SMS sharing is available')
      })
      const data = new FormData()
      data.append('email', this.$User.email)
      data.append('feature', isProVersion ? 'SMS_SHARE_PREMIUM' : 'SMS_SHARE_FREE')
      data.append('created_at', this.$moment().format('DD.MM.YYYY HH:mm:ss'))
      if (this.$Organization) {
        data.append('edrpou', this.$Organization.edrpou)
        data.append('organization', this.$Organization.name)
      }
      fetch(
        'https://script.google.com/macros/s/AKfycbxvp9wQhFHzn7T138Mq6XOZvaFLY3RanrpcVwUm1kChXoaBYOhR4I7nWaTND77gLg9E/exec',
        {
          method: 'POST',
          body: data
        }
      )
    },
    openCopyLinkDialog(inDialog = false, params) {
      if (inDialog) {
        this.contentDialogContentTop.open(params)
      } else {
        this.contentDialog.open(params)
      }
    }
  }
}

export default shareDocumentActions
